import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import withShowHidePassword from 'components/common/hoc/withShowHidePassword/withShowHidePassword'
import Banner from 'components/common/Banner/Banner'
import Button from 'components/common/Button/Button'
import Rules from 'components/common/Rules/Rules'
import { ShowHidePasswordField } from 'components/common/Fields'

// get renderer for showHidePasswordField
const renderShowHidePass = withShowHidePassword({ name: 'password' })(ShowHidePasswordField)

const ResetPasswordForm = ({
  anyTouched,
  form,
  error,
  rules,
  values,
  pristine,
  isPasswordFieldActive,
  isSubmitting,
  handleSubmit,
  handleCustomSubmit,
  handleTokenCancellation,
  ...props
}) =>
  <Form noValidate onSubmit={ handleSubmit(handleCustomSubmit) }>
    <ErrorBanner error_alternative hidden={ !error }>
      { error }
    </ErrorBanner>
    <Field { ...props } { ...form.password } full static component={ renderShowHidePass } />
    <Field { ...props } { ...form.confirmPassword } full static component={ renderShowHidePass } />
    <Field { ...form.hiddenField } component="input" />
    <Rules
      active={ isPasswordFieldActive }
      dirty={ !!values[form.password.name] }
      rules={ rules }
      values={ values } />
    <Buttons>
      <Button full="mobile" stacked="mobile" disabled={ (pristine && !anyTouched) || isSubmitting }>
        SAVE
      </Button>
      <Button full="mobile" stacked="mobile" link type="button" onClick={ handleTokenCancellation }>
        Cancel
      </Button>
    </Buttons>
  </Form>

ResetPasswordForm.propTypes = {
  anyTouched: PropTypes.bool,
  error: PropTypes.string,
  form: PropTypes.shape({
    password: PropTypes.shape({ name: PropTypes.string }),
    confirmPassword: PropTypes.shape(),
    hiddenField: PropTypes.shape()
  }),
  handleCustomSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleTokenCancellation: PropTypes.func,
  isPasswordFieldActive: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  pristine: PropTypes.bool,
  rules: PropTypes.arrayOf(PropTypes.object),
  values: PropTypes.shape()
}

export default ResetPasswordForm

const Buttons = styled.div`
  margin-top: 30px;
`

const Form = styled.form`
  margin-top: 25px;
`

const ErrorBanner = styled(Banner)`
  padding-top: 8px;
`
